/**
 * Deterministic avatar color based on contact name.
 * Returns a Tailwind bg-* class that is consistent for the same name
 * across all components (TicketItem, ChatHeader, BubbleAvatar, ContactDrawer, etc.)
 */
const AVATAR_COLORS = [
    'bg-emerald-600',
    'bg-cyan-600',
    'bg-violet-600',
    'bg-amber-600',
    'bg-rose-600',
    'bg-blue-600',
];

export function getAvatarColor(name) {
    const hash = (name || '').split('').reduce((acc, ch) => acc + ch.codePointAt(0), 0);
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

/**
 * Initials of a name, up to two letters ("Ana Paula de Souza" gives "AP").
 *
 * `fallback` is what to show when there is nothing to take initials from (no name, or only
 * blanks). The default is "??"; a screen that wants "?" or an empty circle passes its own.
 * Words are split on any whitespace and empty pieces are ignored, so a leading, doubled or
 * non-breaking space does not cost a letter.
 */
export function getInitials(name, fallback = '??') {
    if (typeof name !== 'string') return fallback;
    const initials = name
        .split(/\s+/)
        .map(n => n[0])
        .filter(Boolean)
        .join('')
        .toUpperCase()
        .slice(0, 2);
    return initials || fallback;
}
